import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, PageHeader, Button } from 'antd'
//import Filters, { FilterItem, Types } from '../../components/Filters'
import { AnnouncementProvider } from 'context/AnnouncementContext'
import { AnnouncementConsumer } from 'context/AnnouncementContext'
import AnnouncementList from 'components/AnnouncementList'
import AnnouncementForm from 'components/Forms/Announcement'

export default class Announcement extends Component {

  private specieFilterDispatchOptions = {
    options: {
      sort: []
    }
  } as const

  specieListSearch = {
    search: {
      deleted: false
    }
  }

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.specieListSearch.search = payload.search
    }
  }

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="announcement/add">
        <Button type="primary" shape="round">
          Create new announcement
        </Button>
      </Link>
    )
  }

  render() {
    const { permissions, history, goBack, match: { params: { announcementUuid } } }: any = this.props

    return (
      <AnnouncementProvider>
        <AnnouncementConsumer>
          {({ fetching, error, announcements, announcement, pagination, requestAnnouncementList, requestAnnouncementFind, requestAnnouncementCreate, requestAnnouncementUpdate, requestAnnouncementDelete }) => {

            // Edit user
            if (announcementUuid) {
              let addon: any = {
                data: announcement,
                permissions: permissions
              }
              if (announcementUuid !== 'add') {
                addon = {
                  ...addon,
                  uuid: announcementUuid
                }
              }

              return (
                <Card>
                  <PageHeader title={announcementUuid === 'add' ? 'New Announcement' : 'Edit Announcement'} onBack={() => goBack('/admin/announcement')}>
                    <AnnouncementForm
                      {...addon}

                      loading={fetching}
                      error={error}
                      history={history}

                      loadAnnouncement={requestAnnouncementFind}
                      dispatchCreate={requestAnnouncementCreate}
                      dispatchUpdate={requestAnnouncementUpdate}
                    />
                  </PageHeader>
                </Card>
              )
            }

            return (
              <>
                {/*<Card title="Filters" style={{marginBottom: 25}}>
                  <Filters size="medium" loading={fetching} history={history} defaultSubmitOptions={this.specieFilterDispatchOptions} submitDispatch={requestSpecieList} onSubmit={this.handleFiltersSubmit}>
                    {({ values, handleFilterChange }: any) => (
                      <Row gutter={9} style={{width: '100%'}}>
                        <Col xs={24} md={12}>
                          <FilterItem
                            name="uuid"
                            type={Types.INPUT}
                            placeholder="Filter by UUID"
                            value={values['uuid']}
                            size="medium"
                            options={{
                              input: {
                                allowClear: true
                              }
                            }}
                            onChange={handleFilterChange}
                          />
                        </Col>

                        <Col xs={24} md={12}>
                          <FilterItem
                            name="name.ilike"
                            type={Types.INPUT}
                            placeholder="Filter by Name"
                            value={values['name.ilike']}
                            size="medium"
                            options={{
                              input: {
                                allowClear: true
                              }
                            }}
                            onChange={handleFilterChange}
                          />
                        </Col>
                      </Row>
                    )}
                  </Filters>
                </Card>*/}

                <Card title="List of Announcements" extra={this.renderAdd()}>
                  <AnnouncementList
                    loading={fetching}
                    announcements={announcements}
                    pagination={pagination}
                    permissions={permissions}
                    history={history}
                    searchOptions={this.specieListSearch}
                    loadAnnouncements={requestAnnouncementList}
                    deleteAnnouncement={requestAnnouncementDelete}
                  />
                </Card>
              </>
            )
          }}
        </AnnouncementConsumer>
      </AnnouncementProvider>
    )
  }
}
